import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { initClientSourceTracking, initCampaignTracking } from './utils/client-source';
import { initUtmParamTracking } from './utils/utm-params';
import { bootstrapMicrosoftClarity } from './clarity-bootstrap';
import { injectHyrosUniversalScript } from './utils/injectHyrosScript';

injectHyrosUniversalScript();

// Initialize client source tracking (captures UTM parameters and stores in localStorage)
initClientSourceTracking();

bootstrapMicrosoftClarity();

// Initialize campaign tracking (captures utm_campaign in localStorage)
// Note: Campaign tag extraction is handled by backend for security
initCampaignTracking();

// Initialize UTM parameter tracking (logs all detected parameters)
initUtmParamTracking();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);





